import { Injectable } from '@angular/core';
import { throwError } from "rxjs";
import { catchError, switchMap, take } from "rxjs/operators";
import { encryptUsingAES256 } from "@core/utility.service";
import { AuthService } from '@core/auth.service';
import { RequestGameService } from "src/app/services/RequestBodyService/RequestGame/request-game.service";
import { RequestProfileService } from "src/app/services/RequestBodyService/RequestProfile/request-profile.service";

@Injectable({
  providedIn: 'root'
})
export class GamePlayService {

    constructor(
        private authService: AuthService,
        private RequestGameService: RequestGameService,
        private RequestProfileService: RequestProfileService,
    ) {}

    getUserGameInfo(gameDetails, y2p?: string) {
    return new Promise((resolve, reject) => {
      if (gameDetails.game_id && window.navigator.onLine && !gameDetails?.user_game_restriction) {
        this.purchaseFirebaseGame(gameDetails)
          ?.pipe(take(1))
          ?.subscribe(
            (res) => {
              const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
              if (res && res.status?.toLowerCase() === "success") {
                res.play_url = res.play_url + "&token=" + encryptedToken;
                resolve(res);
              } else {
                if (res?.status === "rejected") {
                  this.authService
                    ?.getConstantsMsg(res?.error_code)
                    .then((translatedMsg) => {
                      this.showToaster(translatedMsg, res?.message);
                    })
                    .catch((error) => {
                      return error;
                    });
                  return;
                }
                reject(res);
              }
            },
            (err) => {
              reject(err);
            }
          );
      }
    });
    }

    purchaseFirebaseGame(game: any) {
    try {
      return this.RequestGameService.getPurchaseFiebaseGameRequest(game).pipe(
        switchMap((requestPayload) => {

          if (!requestPayload) {
            return throwError(() => new Error("Invalid request payload"));
          }

          return this.authService
            ?.getV2CloudFunction("apiv2", requestPayload)
            .pipe(
              catchError((error) => {

                this.authService
                  .getConstantsMsg("1015")
                  .then((translatedMsg) => {
                    const defaultMsg = {
                      message: {
                        line_1: "Something went wrong!",
                        line_2: "",
                      },
                      style: {
                        icon: "tick circle error.svg",
                        type: "error",
                      },
                    };
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                  })
                return throwError(() => error);
              })
            );
        })
      );
    } catch (error) {
      return throwError(() => error);
    }
    }


    showToaster(translatedMsg: string, initialMsg: string) {
    const defaultMsg = {
    message: {
        line_1: initialMsg,
        line_2: "",
    },
    style: {
        icon: "tick circle error.svg",
        type: "Error",
    },
    };
    this.authService.showToastMessage(translatedMsg, defaultMsg);
    }

    purchaseGame(gameId: string) {
        try {
        // V2
        return this.authService.getV2CloudFunction(
            "postasynceventsv2",
            this.RequestGameService.getPurchaseGameRequest(gameId)
        );
        // V1
        /* const api = this.angularFireFunctions.httpsCallable("postAsyncEvents");
        return api(this.requestBodyService.getPurchaseGameRequest(gameId)); */
        } catch (error) {
        return error;
        }
    }

    playGame(gameId) {
        try {
        // V2
        return this.authService.getV2CloudFunction("postasynceventsv2", this.RequestGameService.playGame(gameId));
        // V1
        /* const api = this.angularFireFunctions.httpsCallable("postAsyncEvents");
        return api(this.requestBodyService.playGame(gameId)); */
        } catch (error) {
        return error;
        }
    }

    private purchaseAPI(gameDetails: any, resolve: (value: unknown) => void, reject: (reason?: any) => void) {
        try {
        this.purchaseGame(gameDetails.game_id)
            .subscribe(
            (data) => {
                if (data.status === "success") {
                resolve(data.play_url);
                } else {
                reject(data?.message);
                }
            },
            (err) => {
                return err;
            }
            )
            .catch((error) => error);
        } catch (e) {
        return e;
        }
    }

    quitAdventure(adventureId: string) {
    // const api = this.angularFireFunctions.httpsCallable("api");
    // return api(this.requestBodyService.quitAdventureRequest(adventureId));
    return this.authService?.getV2CloudFunction("apiv2", this.RequestProfileService.quitAdventureRequest(adventureId));
    }


}